var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertActiveWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.333 8.181a2.667 2.667 0 1 0 0-5.334 2.667 2.667 0 0 0 0 5.334Z",
    stroke: "url(#paint0_linear_916_8718)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.665 19.667a1.856 1.856 0 0 0 3.56 0M9.443 3V1m6.687 9.966C16.3 16.083 17.445 17 17.445 17H1.443s1.333-1.703 1.333-7.334a6.673 6.673 0 0 1 8.644-6.369",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_916_8718",
    x1: 13.798,
    y1: 0.929,
    x2: 19.29,
    y2: 1.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6836A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA05D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertActiveWhite);
export default __webpack_public_path__ + "static/media/alertActiveWhite.6dd9e9bdb6264762b689e0486ad5d439.svg";
export { ForwardRef as ReactComponent };